export default {
    comments: {
        title: '评论列表',
        empty: '暂无评论',
        fetchFailed: '获取评论列表失败',
        deleteSuccess: '评论已删除',
        deleteFailed: '删除评论失败',
        deleteConfirm: '确定软删除该评论？根评论删除会级联删除全部未删除回复。',
        deleteReason: '删除原因',
        deleteReasonPlaceholder: '请输入删除原因',
        deleteReasonRequired: '请输入删除原因',
        deleteSubmit: '确认删除',
        missingOperator: '无法获取当前操作人 ID，请重新登录后再试',
        exportSuccess: '导出任务已创建，请稍后在下载管理中查看',
        exportFailed: '导出失败',
        preview: '预览',
        previewTitle: '视频预览',
        history: '历史',
        historyTitle: '评论操作历史',
        historyEmpty: '暂无操作记录',
        historyFetchFailed: '获取评论操作历史失败',
        historyAction: '操作类型',
        historyReason: '原因',
        historyOperator: '操作人',
        historyTime: '操作时间',
        sort: {
            label: '发布时间',
            asc: '升序',
            desc: '降序',
        },
        columns: {
            no: 'No.',
            id: '评论 ID',
            content: '评论内容',
            level: '评论层级与上下文',
            related: '关联视频信息',
            author: '评论人信息',
            stats: '点赞/回复数',
            createdAt: '发布时间',
            auditStatus: '审核状态',
            action: '操作',
        },
        level: {
            root: '主评论',
            reply: '二级回复',
            replyTo: '回复 @{nickname} (UID: {uid})',
        },
        related: {
            type: '关联类型',
            videoId: '关联视频ID',
            episode: '第{n}集',
            drama: '短剧',
            video: '视频',
        },
        stats: {
            like: '点赞：{n}',
            reply: '回复数：{n}',
        },
        search: {
            id: '评论 ID',
            content: '评论内容',
            userId: '评论用户 UID',
            itemType: '关联类型',
            workId: '关联视频 ID',
            level: '评论层级',
            auditStatus: '审核状态',
            createdAtStart: '发布时间起',
            createdAtEnd: '发布时间止',
        },
        itemType: {
            all: '全部',
            EPISODE: '短剧',
            SHORT_VIDEO: '视频',
        },
        levelFilter: {
            all: '全部',
            root: '一级评论',
            reply: '二级回复',
        },
        auditStatus: {
            all: '全部',
            APPROVED: '已通过',
            DELETED: '已删除',
            PENDING: '待审核',
        },
    },
};
